const baseURL = 'https://galeri.kexe.mx/';

export default baseURL;
